var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"content"},[_c('el-main',{staticStyle:{"margin-top":"2px","padding":"40px"}},[_c('h2',{staticStyle:{"text-align":"center","color":"#555"}},[_vm._v("您当前没有权限使用该系统，请联系管理员设置权限！")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }